var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 163 48",
    width: 163,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 26.2127,
    x2: 6.07377,
    y1: 10.4517,
    y2: 30.5906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 40.6541,
    x2: 11.6178,
    y1: 24.0018,
    y2: 24.0018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#ffa500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 29.8455,
    x2: 2.53551,
    y1: 26.7554,
    y2: 54.0654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 8.80961,
    x2: 21.0047,
    y1: 0.211545,
    y2: 12.4065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    height: 48,
    rx: 6,
    width: 162,
    x: 0.052734
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m81.816 26.1024c-2.8224 0-5.1228 2.1456-5.1228 5.1036 0 2.9388 2.3004 5.1036 5.1228 5.1036s5.1228-2.1648 5.1228-5.1036c0-2.958-2.3004-5.1036-5.1228-5.1036zm0 8.1972c-1.5468 0-2.8812-1.2756-2.8812-3.0936 0-1.8372 1.3344-3.0936 2.8812-3.0936s2.88 1.2564 2.88 3.0936c0 1.8168-1.3332 3.0936-2.88 3.0936zm-11.1768-8.1972c-2.8224 0-5.1228 2.1456-5.1228 5.1036 0 2.9388 2.3004 5.1036 5.1228 5.1036s5.1228-2.1648 5.1228-5.1036c.0012-2.958-2.3004-5.1036-5.1228-5.1036zm0 8.1972c-1.5468 0-2.88-1.2756-2.88-3.0936 0-1.8372 1.3344-3.0936 2.88-3.0936 1.5468 0 2.88 1.2564 2.88 3.0936.0012 1.8168-1.3332 3.0936-2.88 3.0936zm-13.2936-6.6312v2.1648h5.1816c-.1548 1.218-.5604 2.1072-1.1796 2.7264-.7536.7536-1.9332 1.5852-4.002 1.5852-3.1896 0-5.6832-2.5716-5.6832-5.7612s2.4936-5.7612 5.6832-5.7612c1.7208 0 2.9772.6768 3.9048 1.5468l1.5276-1.5276c-1.2948-1.2372-3.0156-2.1852-5.4324-2.1852-4.3692 0-8.0424 3.5568-8.0424 7.926s3.6732 7.926 8.0424 7.926c2.358 0 4.1376-.7728 5.5296-2.2236 1.4304-1.4304 1.8756-3.4416 1.8756-5.0652 0-.5028-.0384-.9672-.1164-1.3536h-7.2888zm54.3694 1.6812c-.425-1.1412-1.721-3.2484-4.369-3.2484-2.629 0-4.813 2.0688-4.813 5.1036 0 2.8608 2.165 5.1036 5.065 5.1036 2.339 0 3.692-1.4304 4.253-2.262l-1.74-1.1604c-.58.8508-1.373 1.4112-2.513 1.4112-1.141 0-1.952-.522-2.474-1.5468l6.824-2.8224zm-6.96 1.7016c-.057-1.9716 1.528-2.9772 2.668-2.9772.889 0 1.643.444 1.895 1.0824zm-5.5486 4.9488h2.2426v-15.0012h-2.2426zm-3.6732-8.7576h-.0768c-.5028-.5988-1.4688-1.1412-2.6868-1.1412-2.5524 0-4.8912 2.2428-4.8912 5.1228 0 2.8608 2.3388 5.0844 4.8912 5.0844 1.218 0 2.184-.5412 2.6868-1.1604h.0768v.7344c0 1.9524-1.044 2.9964-2.7264 2.9964-1.3728 0-2.2236-.9864-2.5716-1.8168l-1.9524.8124c.5604 1.3536 2.0496 3.0156 4.524 3.0156 2.6292 0 4.8528-1.5468 4.8528-5.316v-9.1632h-2.1264zm-2.5704 7.0572c-1.5468 0-2.8416-1.2948-2.8416-3.0744 0-1.7976 1.2948-3.1128 2.8416-3.1128 1.5276 0 2.7252 1.314 2.7252 3.1128 0 1.7784-1.1976 3.0744-2.7252 3.0744zm29.2572-13.3008h-5.365v15.0012h2.238v-5.6832h3.126c2.481 0 4.921-1.7964 4.921-4.6584s-2.438-4.6596-4.92-4.6596zm.058 7.23h-3.185v-5.142h3.185c1.674 0 2.624 1.386 2.624 2.5716 0 1.1616-.95 2.5704-2.624 2.5704zm13.838-2.154c-1.621 0-3.3.714-3.995 2.2968l1.989.8304c.424-.8304 1.215-1.1004 2.046-1.1004 1.158 0 2.335.6948 2.354 1.9296v.1548c-.406-.2316-1.274-.5796-2.335-.5796-2.142 0-4.324 1.1772-4.324 3.378 0 2.0076 1.757 3.3 3.725 3.3 1.506 0 2.335-.6756 2.856-1.4664h.077v1.158h2.161v-5.7516c0-2.664-1.987-4.1496-4.554-4.1496zm-.271 8.2212c-.733 0-1.757-.3672-1.757-1.2732 0-1.158 1.274-1.602 2.374-1.602.984 0 1.447.2124 2.046.5016-.173 1.3896-1.37 2.3736-2.663 2.3736zm12.699-7.8936-2.566 6.504h-.077l-2.663-6.504h-2.412l3.995 9.09-2.278 5.0568h2.335l6.158-14.1468zm-20.168 9.5976h2.239v-15.0012h-2.239z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m88.3837 14.6688c-.708.7284-1.5876 1.0908-2.64 1.0908s-1.932-.3636-2.6388-1.0908c-.708-.7272-1.0608-1.6176-1.0608-2.67s.3528-1.9428 1.0608-2.67001c.7068-.7284 1.5864-1.092 2.6388-1.092 1.0464 0 1.9248.366 2.6352 1.0968.7104.73081 1.0656 1.61881 1.0656 2.66521 0 1.0536-.354 1.944-1.0608 2.67zm-4.596-.6024c.5328.54 1.1844.8088 1.956.8088s1.4232-.27 1.956-.8088c.5328-.54.8004-1.2288.8004-2.0664s-.2676-1.5276-.8004-2.06641c-.5316-.54-1.1844-.8088-1.956-.8088s-1.4232.27-1.956.8088c-.5316.54001-.7992 1.22881-.7992 2.06641s.2676 1.5264.7992 2.0664z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.9545 12.2916c0 1.0056-.2976 1.806-.894 2.4036-.6768.7104-1.56 1.0656-2.6448 1.0656-1.0392 0-1.9236-.36-2.6496-1.08-.7272-.7212-1.0908-1.614-1.0908-2.6796 0-1.0668.3636-1.9596 1.0908-2.67962.726-.7212 1.6104-1.0812 2.6496-1.0812.516 0 1.0092.1008 1.4772.3012.4692.2016.8448.4692 1.1256.804l-.6324.6336c-.4764-.57-1.1328-.8544-1.9716-.8544-.7584 0-1.4136.2664-1.9668.7992-.552.53282-.828 1.22402-.828 2.07602s.276 1.5432.8292 2.0772c.5532.5328 1.2084.7992 1.9668.7992.804 0 1.4748-.2676 2.0112-.804.348-.3492.5496-.8352.6036-1.458h-2.6148v-.8664h3.4884c.0348.1884.0504.3696.0504.5436z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.4865 9.28439h-3.2784v2.28241h2.9568v.8652h-2.9568v2.2824h3.2784v.8856h-4.2036v-7.20001h4.2036z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.4613 15.6h.9252v-6.31561h2.0112v-.8844h-4.9476v.8844h2.0112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.9785 15.6v-7.20001h.9252v7.20001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.0801 15.6h.9252v-6.31561h2.0112v-.8844h-4.9476v.8844h2.0112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.7429 8.39999v7.20001h.9228v-4.4856l-.0396-1.38721h.0396l3.6612 5.87281h.966v-7.20001h-.9252v4.21441l.0396 1.3872h-.0396l-3.4992-5.60161z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m88.3837 14.6688c-.708.7284-1.5876 1.0908-2.64 1.0908s-1.932-.3636-2.6388-1.0908c-.708-.7272-1.0608-1.6176-1.0608-2.67s.3528-1.9428 1.0608-2.67001c.7068-.7284 1.5864-1.092 2.6388-1.092 1.0464 0 1.9248.366 2.6352 1.0968.7104.73081 1.0656 1.61881 1.0656 2.66521 0 1.0536-.354 1.944-1.0608 2.67zm-4.596-.6024c.5328.54 1.1844.8088 1.956.8088s1.4232-.27 1.956-.8088c.5328-.54.8004-1.2288.8004-2.0664s-.2676-1.5276-.8004-2.06641c-.5316-.54-1.1844-.8088-1.956-.8088s-1.4232.27-1.956.8088c-.5316.54001-.7992 1.22881-.7992 2.06641s.2676 1.5264.7992 2.0664z",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.9545 12.2916c0 1.0056-.2976 1.806-.894 2.4036-.6768.7104-1.56 1.0656-2.6448 1.0656-1.0392 0-1.9236-.36-2.6496-1.08-.7272-.7212-1.0908-1.614-1.0908-2.6796 0-1.0668.3636-1.9596 1.0908-2.67962.726-.7212 1.6104-1.0812 2.6496-1.0812.516 0 1.0092.1008 1.4772.3012.4692.2016.8448.4692 1.1256.804l-.6324.6336c-.4764-.57-1.1328-.8544-1.9716-.8544-.7584 0-1.4136.2664-1.9668.7992-.552.53282-.828 1.22402-.828 2.07602s.276 1.5432.8292 2.0772c.5532.5328 1.2084.7992 1.9668.7992.804 0 1.4748-.2676 2.0112-.804.348-.3492.5496-.8352.6036-1.458h-2.6148v-.8664h3.4884c.0348.1884.0504.3696.0504.5436z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m62.4865 9.28439h-3.2784v2.28241h2.9568v.8652h-2.9568v2.2824h3.2784v.8856h-4.2036v-7.20001h4.2036z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m65.4613 15.6h.9252v-6.31561h2.0112v-.8844h-4.9476v.8844h2.0112z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m71.9785 15.6v-7.20001h.9252v7.20001z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m76.0801 15.6h.9252v-6.31561h2.0112v-.8844h-4.9476v.8844h2.0112z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m90.7429 8.39999v7.20001h.9228v-4.4856l-.0396-1.38721h.0396l3.6612 5.87281h.966v-7.20001h-.9252v4.21441l.0396 1.3872h-.0396l-3.4992-5.60161z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m12.5751 9.04558c-.3492.3696-.5556.9432-.5556 1.68602v26.5392c0 .744.2064 1.3164.5556 1.686l.0888.0864 14.8668-14.8668v-.1752-.1752l-14.8668-14.86802z",
    fill: "url(#a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m32.4865 29.1348-4.9548-4.9572v-.1752-.1752l4.956-4.956.1116.0636 5.8716 3.336c1.6776.9528 1.6776 2.5116 0 3.4656l-5.8716 3.336z",
    fill: "url(#b)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m32.5996 29.07-5.0676-5.0688-14.9568 14.9556c.5532.5856 1.4652.6576 2.4936.0732z",
    fill: "url(#c)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m32.5994 18.9324-17.5296-9.96002c-1.0284-.5844-1.9404-.5112-2.4936.0732l14.9556 14.95562z",
    fill: "url(#d)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m32.488 28.9584-17.418 9.8964c-.9744.5532-1.8456.5172-2.4048.0132l-.09.09.0888.0864c.5592.504 1.4304.5412 2.4048-.0132l17.5296-9.96z",
    fill: "#000",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m12.5751 38.7816c-.3492-.3696-.5556-.9432-.5556-1.686v.1752c0 .7428.2064 1.3164.5556 1.686l.09-.09z",
    fill: "#000",
    opacity: 0.12
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m38.471 25.5588-5.9832 3.3996.1116.1116 5.8716-3.336c.8388-.4764 1.2576-1.104 1.2576-1.7316-.0708.5676-.498 1.1244-1.2576 1.5564z",
    fill: "#000",
    opacity: 0.12
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m15.0687 9.14759 23.4012 13.29601c.7608.432 1.1868.9888 1.2576 1.5576 0-.6276-.4188-1.2564-1.2576-1.7328l-23.4012-13.29601c-1.6776-.9528-3.0492-.162-3.0492 1.75921v.1764c0-1.92121 1.3728-2.71321 3.0492-1.76041z",
    fill: "#fff",
    opacity: 0.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.1be9dbd7b3258332fe982cee326105c2.svg";
export { ForwardRef as ReactComponent };